import { Empty, Layout } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

type Props = {
  collapsed: boolean;
};

const ContentLayout = ({ collapsed }: Props) => {
  const { Content } = Layout;
  const { t } = useTranslation();
  return (
    <Content
      style={collapsed === true ? { marginLeft: "0px" } : { marginLeft: "0px" }}
    >
      <Outlet />
    </Content>
  );
};

export default ContentLayout;
